<div class="main-container mat-app-background">
  <lfw-navigation-toolbar>
    <ng-container navStart>
      <div class="hide-gt-mobile">
        <button mat-icon-button (click)="sidenav().toggle()">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
    </ng-container>
    <ng-container navCenter>
      <div class="nav-buttons hide-lt-mobile">
        @for (item of availableItems$ | async; track item.id) {
          <div [class.active-link]="rla.isActive">
            <a
              class="top-button"
              mat-button
              [routerLink]="item.route"
              routerLinkActive="active"
              #rla="routerLinkActive"
              [matTooltipTouchGestures]="'off'"
              [matTooltip]="showToolTip() ? item.text : ''">
              <mat-icon>{{ item.icon }}</mat-icon>
              <span class="hide-lt-tablet">&nbsp;{{ item.text }}</span>
            </a>
          </div>
        }
        @if (menuService.cmdUser) {
          <lfw-menu [menuItems]="userCommands$ | async">
            <a
              routerLinkActive="active"
              class="top-button"
              mat-button
              [matTooltip]="showToolTip() ? menuService.cmdUser.text : ''">
              <mat-icon>{{ menuService.cmdUser.icon }}</mat-icon>
              <span class="hide-lt-tablet">&nbsp;{{ menuService.cmdUser.text }}</span>
            </a>
          </lfw-menu>
        }
      </div>
    </ng-container>
  </lfw-navigation-toolbar>

  <mat-sidenav-container>
    @if (isMenuVisible) {
      <mat-sidenav color="primary" #sidenav mode="over" opened="false" class="hide-gt-mobile">
        <mat-nav-list>
          @for (mitem of availableItems$ | async; track mitem.id) {
            <div>
              <a mat-list-item [routerLink]="mitem.route" routerLinkActive="active-link">
                <mat-icon>{{ mitem.icon }}</mat-icon>
                <span>&nbsp;{{ mitem.text }}</span>
              </a>
            </div>
          }
          <lfw-menu [menuItems]="userCommands$ | async">
            @if (menuService.cmdUser) {
              <a mat-list-item>
                <mat-icon>{{ menuService.cmdUser.icon }}</mat-icon>
                <span>&nbsp;{{ menuService.cmdUser.text }}</span>
              </a>
            }
          </lfw-menu>
        </mat-nav-list>
      </mat-sidenav>
    }

    <mat-sidenav-content class="sidenav-content">
      <div class="main-outlet-container">
        <ng-content />
      </div>

      @if (isInfoBarVisible) {
        <footer class="statusbar">
          <span class="statusbar-item">
            <mat-icon aria-hidden="true">person</mat-icon>
            <span>{{ userName }}</span>
          </span>

          @if (hasProjectName) {
            <lfw-toolbar-divider />
            <span class="statusbar-item">
              <mat-icon aria-hidden="true">local_library</mat-icon>
              <span>{{ projectName }}</span>
            </span>
          }

          @if (hasInfoText) {
            <lfw-toolbar-divider />
            <span class="statusbar-item">
              <mat-icon aria-hidden="true">info</mat-icon>
              <span>{{ infoText }}</span>
            </span>
          }
          <span class="spacer"></span>
          <span class="statusbar-item">{{ shortVersion }}</span>
        </footer>
      }
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
